import { Action, ActionCreator, Dispatch } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { IUserProfile } from '../../Models/Profile/IUserProfile';
import { IProfileApi } from '../../Services/API/Profile/IProfileApi';
import { IAppStore } from '../IAppStore';
import * as Constants from './Constants'
import * as Services from '../../Services/Services';


export interface ISetProfile extends Action<Constants.SET_PROFILE_TYPE> {
    profile: IUserProfile
}

export function setProfile(profile: IUserProfile): ISetProfile {
    return {
        type: Constants.SET_PROFILE,
        profile: profile
    }
}


export const GetProfile: ActionCreator<
    ThunkAction<
        Promise<any>,       // The type of the last action to be dispatched - will always be promise<T> for async actions
        IAppStore,          // The type for the data within the last action
        null,               // The type of the parameter for the nested function 
        ISetProfile         // The type of the last action to be dispatched
    >> = (id: number, zoom?: number) => {
        return async (dispatch: Dispatch, getState) => {
            const profileApi = Services.ServicesProvider.GetService<IProfileApi>(Services.ProfileApi);
            const profile = await profileApi.getLoginUserInfo();
            if (profile.isSuccess && profile.data)
            {
                dispatch(setProfile(profile.data));
            }
            
        };
    };




export type ProfileActions = ISetProfile; 